import type { JSX } from 'react';
import { Button } from '@/components/ui/button';

interface WizardFooterActionsProps {
  canContinue: boolean;
  onAdd: () => void;
  onContinue: () => void;
}

export function WizardFooterActions({
  canContinue,
  onAdd,
  onContinue,
}: WizardFooterActionsProps): JSX.Element {
  return (
    <div className="flex flex-col-reverse justify-end gap-3 sm:flex-row">
      <Button variant="outline" onClick={onAdd}>
        Add another work experience
      </Button>
      <Button disabled={!canContinue} onClick={onContinue}>
        Continue to review
      </Button>
    </div>
  );
}
